import hasPermission from "./HasPermission";

const createSidebarMenus = (permissions: string[] = [], routes: any[] = []) => {
  let results: any = [];
  createRoutes(routes, results, permissions);
  return clearRoutes(results);
};

const createRoutes = (routes: any, results?: any, permissions: string[] = []) => {
  routes.forEach((item: any) => {
    if (item.title && item.sidebar) {
      const hasPerm = hasPermission(item.permissions, permissions);
      if (hasPerm) {
        let itemRes: any = {
          path: item.pathSideBar || item.path,
          title: item.title,
          icon: item.icon,
          iconSrc: item.iconSrc,
          iconTag: item.iconTag,
          onClick: item?.onClick,
          onlyInMobile: item?.onlyInMobile,
          className: item?.className,
        };
        if (item.routes && item.routes.length) {
          itemRes.children = [];
        }
        results.push(itemRes);
        if (item.routes) {
          createRoutes(item.routes, itemRes.children, permissions);
        }
      }
    }
  });
};

const checkChildrenEmpty = (route: any) => {
  if (route && route.children && route.children.length) {
    route.children = route.children
      .map((childRoute: any) => checkChildrenEmpty(childRoute))
      .filter((childRoute: any) => {
        return !(childRoute.children && !childRoute.children.length);
      });
    return route;
  } else {
    return route;
  }
};

const clearRoutes = (routes: any) => {
  return routes.filter((item: any) => {
    const route = checkChildrenEmpty(item);
    return !(route.children && !route.children.length);
  });
};

export default createSidebarMenus;
